import { putFile } from '@/api/api'
import { MaterialServiceProxy } from '@/service-proxies/app-v2/material.service-proxies'
import {
  WarehouseLocationServiceProxy,
  WarehouseMaterialStockServiceProxy,
  WarehouseAreaServiceProxy
} from '@/service-proxies/app-v2/warehouse.service-proxies'
import { SupplierServiceProxy } from '@/service-proxies/app-v2/client.service-proxies'
import { ServiceProxy as ResourceServiceProxy } from '@/service-proxies/app-v2/resource.service-proxies'

const resourceService = new ResourceServiceProxy()
const ssp = new SupplierServiceProxy()
const whasp = new WarehouseAreaServiceProxy()
const msp = new MaterialServiceProxy()
const whmssp = new WarehouseMaterialStockServiceProxy()
const whlsp = new WarehouseLocationServiceProxy()
import { columns } from './tableColumns'

export default {
  props: {
    tableDef: {
      type: Object,
      default: () => ({})
    },
    tableData: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      materialList: [], // 物料列表
      materialAddList: [] // 所有的物料列表
    }
  },
  async created() {
    this.areaList = await whasp.listWarehouseArea('')
  },
  watch: {
    tableData: {
      handler() {
        this.editingKey = ''
        this.cacheData = this.dataSource
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    columns() {
      return columns.map((item) => {
        if (item.dataIndex === 'isMustCheck') {
          item.customRender = (text) => {
            if (text) {
              return text === 1 ? this.$t('yes') : this.$t('no')
            }
          }
        }
        if (this.tableDef.hasOutOrder) {
          if (item.dataIndex === 'totalNum') {
            item.title = 'page_plan_delivery_quantity'
            item.dataIndex = 'stockOutNum'
          }
        } else {
          if (item.dataIndex === 'stockOutNum') {
            item.title = 'page_material_warehousing_totalNum'
            item.dataIndex = 'totalNum'
          }
        }
        return {
          ...item,
          title: this.$t(item.title)
        }
      })
    }
  },
  methods: {
    disabled(record) {
      return this.editingKey !== '' || (this.tableDef.isPlan ? false : record.materialStatus === 1)
    },
    // 物料修改
    changeMaterial(value, record) {
      const newData = [...this.dataSource]
      console.log(value, record)
      const material = this.materialList.find((res) => res.displayCode === value)
      const checkTarget = newData.find((res) => res.id === material.id)
      if (checkTarget) {
        this.$message.warning(this.$t('page_material_warehouse_cannot_be_selected'))
        return
      }
      const target = newData.find((res) => res.key === record.key)
      const area = this.areaList.find((item) => item.id == this.areaId)
      if (area) {
        whlsp.listWarehouseLocationByMaterial(area.id, '', material.id).then((res) => {
          this.locationList = res
        })
      }
      if (target) {
        target.id = material.id
        target.materialId = material.id
        target.barCode = material.barCode
        target.displayCode = material.displayCode
        target.materialTypeName = material.typeName
        target.materialCode = material.code
        target.materialName = material.name
        target.isMustCheck = material.isMustCheck
        target.materialStandardModel = material.standardModel
        target.materialStuff = material.stuff
        target.materialUnit = material.unit
        target.stuff = material.stuff
        target.areaId = area.id
        target.areaName = area.name
        this.dataSource = newData
        this.cacheData = JSON.parse(JSON.stringify(this.dataSource))
      }
    },
    // 保存编辑
    saveTableEdit(key) {
      const newData = [...this.dataSource]
      const newCacheData = [...this.cacheData]
      const target = newData.filter((item) => key === item.key)[0]
      const targetCache = newCacheData.filter((item) => key === item.key)[0]
      if (target.materialId === '') {
        this.$message.warning(this.$t('page_business_select_material'))
        return
      }
      if (target.areaId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_area'))
        return
      }
      if (target.locationId === '') {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_location'))
        return
      }
      if (target.stockInNum === undefined || target.stockInNum === null) {
        this.$message.warning(this.$t('page_material_ware_not_to_total_number'))
        return
      }
      if (
        !this.tableDef.hasOutOrder &&
        (target.totalNum === undefined || target.totalNum === null)
      ) {
        this.$message.warning(this.$t('page_material_ware_not_to_stockin_number'))
        return
      }
      if (target && targetCache) {
        delete target.editable
        this.dataSource = newData
        Object.assign(targetCache, target)
        this.cacheData = newCacheData
      }
      this.editingKey = ''
    },
    // 取消编辑
    cancelTableEdit(key) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => key === item.key)[0]
      this.editingKey = ''
      if (target) {
        Object.assign(target, this.cacheData.filter((item) => key === item.key)[0])
        delete target.editable
        this.dataSource = newData
      }
    },
    // 获取供应商列表
    getSupplierList() {
      ssp.getPageSupplier(1, '', 999999).then((res) => {
        this.supplierList = res.records
      })
    },
    changeSupplierList(value) {
      ssp.getPageSupplier(1, value, 999999).then((res) => {
        this.supplierList = res.records
      })
    },
    // 获取库位列表
    getLocationList(record) {
      if (record.areaId) {
        whlsp.listWarehouseLocationByMaterial(record.areaId, '', record.id).then((res) => {
          this.locationList = res
        })
      }
    },
    changeLocationList(value, record) {
      if (record.areaId) {
        whlsp.listWarehouseLocationByMaterial(record.areaId, value, record.id).then((res) => {
          this.locationList = res
        })
      }
    },
    // 获取物料列表
    async changeMaterialList(value) {
      this.materialList = await msp.getMaterialList(0, value, undefined, '')
      this.materialList.map((item) => {
        if (item.standardModel) {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})——${item.standardModel}(${this.$t('page_material_warehousing_specifications')})`
          this.materialAddList.push({ id: item.id, code: str })
        } else {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})`
          this.materialAddList.push({ id: item.id, code: str })
        }
      })
    },
    async getALLMaterial() {
      this.materialList = await msp.getMaterialList(0, '', undefined, '')
      this.materialList.map((item) => {
        if (item.standardModel) {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})——${item.standardModel}(${this.$t('page_material_warehousing_specifications')})`
          this.materialAddList.push({ id: item.id, code: str })
        } else {
          const str = `${item.code}(${this.$t('page_plan_item_no')})——${item.name}(${this.$t(
            'page_business_material_name'
          )})`
          this.materialAddList.push({ id: item.id, code: str })
        }
      })
    },
    // 添加物料
    addMaterial() {
      const { count, dataSource } = this
      this.editingKey = count
      const newData = {
        key: count,
        editable: true,
        id: '',
        materialId: '',
        barCode: '',
        materialTypeName: '',
        materialCode: '',
        materialName: '',
        batchCode: '',
        isMustCheck: '',
        materialStandardModel: '',
        materialStuff: '',
        materialUnit: '',
        number: '',
        totalNum: '',
        stockInNum: '',
        price: '',
        remark: '',
        areaId: '',
        areaName: '',
        locationId: '',
        locationName: '',
        testResult: null,
        contentType: '',
        supplierId: '',
        fileName: '',
        fileObjectKey: '',
        stuff: ''
      }
      this.dataSource = [...dataSource, newData]
      this.count = count + 1
    },
    // 删除物料
    handleDelete(record) {
      const dataSource = [...this.dataSource]
      this.dataSource = dataSource.filter((item) => item.key !== record.key)
    },
    // 编辑物料
    edit(record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      const area = this.areaList.find((item) => item.id == this.areaId)
      if (area) {
        whlsp.listWarehouseLocation(area.id, '', record.id).then((res) => {
          this.locationList = res
        })
      }
      this.editingKey = record.key
      if (target) {
        target.editable = true
        this.dataSource = newData
      }
    },
    handleChange(value, record, column) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      if (target) {
        target[column] = value
        this.dataSource = newData
      }
    },
    handleChangeLocationId(value, record) {
      const newData = [...this.dataSource]
      const target = newData.filter((item) => record.key === item.key)[0]
      let num = 0
      let same = false
      newData.forEach((res) => {
        if (res.locationId === value && record.id === res.id) {
          same = true
        }
      })
      if (same) {
        this.$message.warning(this.$t('page_plan_refund_confirmation_not_be_same'))
        return
      }
      whmssp.listWarehouseMaterialStock(value, record.id).then((res) => {
        if (res) {
          num = res.length > 0 ? res[0].locationNum : num
          if (target) {
            target['locationId'] = value
            const area = this.locationList.find((res) => res.id === value)
            target['locationName'] = area.warehouseLocationName
            target['number'] = num + ''
            this.dataSource = newData
          }
        }
      })
    },
    // 文件上传
    beforeUpload(file) {
      const isGt20M = file.size / 1024 / 1024 > 20
      if (isGt20M) {
        this.$message.error(this.$t('page_my_document_notsupport'))
        return false
      }
    },
    handleChangefileName(req, record) {
      let uploadFile = req.file
      let fileOriginalName = uploadFile.name

      const formData = new FormData()
      formData.append('file', uploadFile)

      putFile(
        formData,
        (res) => {
          let fileName = res.data.data.name
          resourceService.statFileUsingGET(fileName).then((statRes) => {
            let ossFile = statRes.data

            const newData = [...this.dataSource]
            const target = newData.filter((item) => record.key === item.key)[0]
            if (target) {
              target['fileName'] = fileOriginalName
              target['fileObjectKey'] = ossFile.name
              target['contentType'] = ossFile.contentType
              this.dataSource = newData
            }
          })
        },
        null
      )
    },
    findSupplier(value) {
      const data = this.supplierList.find((res) => res.id === value)
      return data ? data.name : ''
    }
  }
}
